import * as Scrivito from "scrivito";

const LocalizedKeyWidget = Scrivito.provideWidgetClass("LocalizedKeyWidget", {
  attributes: {
    key: "string",
    de: "string",
    en: "string",
  },
  onlyInside: "NewsCategoryConfigWidget",
});

export default LocalizedKeyWidget;
